import React, { Component } from 'react';

import { Redirect } from 'react-router-dom';
import { cssTransition, toast, ToastContainer } from 'react-toastify';
const { Raven } = window;

import BookingForm from 'components/BookingForm';
import RewardMenu from 'components/RewardMenu/RewardMenu';

import APIHandler from 'config/APIHandler';
import StorageHandler from 'config/StorageHandler';

import 'react-toastify/dist/ReactToastify.css';

import i18n from 'i18n-react';
import { baseAppId, storageKeys, userKeys } from 'settings';

const checkInputValidityFields = () => {
  const inputs = document.getElementsByTagName('input');
  const inputArray = [];
  const selects = document.getElementsByTagName('select');
  const selectArray = Array.from(selects);
  Array.from(inputs).forEach((input) => {
    if (!input.name.includes('olark') && input.name !== '') {
      inputArray.push(input);
    }
  });

  const emptyFields = [];
  Array.from(inputs).forEach((input) => {
    if (input.name && input.name !== '') {
      if (input.checkValidity() === false) {
        const name = input.name
          .replace(/reg_/g, '')
          .replace(/_/g, ' ')
          .replace(/([a-z])([A-Z])/g, '$1 $2')
          .replace(/(^\w|\s\w)/g, (m) => m.toUpperCase());
        emptyFields.push(name);
      }
    }
  });

  selectArray.forEach((select) => {
    if (select.selectedIndex === 0) {
      if (!select.name.includes('airline')) {
        const name = select.name
          .replace(/reg_/g, '')
          .replace(/_/g, ' ')
          .replace(/([a-z])([A-Z])/g, '$1 $2')
          .replace(/(^\w|\s\w)/g, (m) => m.toUpperCase());
        emptyFields.push(name);
      }
    }
  });

  return emptyFields;
};

const checkInputValidity = () => {
  const inputs = document.getElementsByTagName('input');
  const inputArray = [];
  const selects = document.getElementsByTagName('select');
  const selectArray = [];

  Array.from(inputs).forEach((input) => {
    if (input.name && !input.name.includes('airline')) {
      inputArray.push(input);
    }
  });

  Array.from(selects).forEach((select) => {
    if (!select.name.includes('airline')) {
      selectArray.push(select);
    }
    // console.log('select', select, select.selectedIndex);
  });

  return inputArray.every((val) => val.checkValidity() === true) && selectArray.every((val) => val.selectedIndex !== 0);
};

const Zoom = cssTransition({
  enter: 'zoomIn',
  exit: 'zoomOut',
  duration: [500, 800],
});

class BookingFormView extends Component {
  constructor() {
    super();
    this.state = {
      confirmNumber: '',
      bookingNumber: '',
      arrivalDate: '',
      ticketNumber: '',
      departureDate: '',
      lengthOfStay: 0,
      agentEmail: '',
      agentFirstName: '',
      agentLastName: '',
      agentCompany: '',
      postalCode: '',
      agentCity: '',
      agentCountry: '',
      numberOfTravelers: 0,
      routing: '',
      files: '',
      Sentry: Raven,

      redirect: null,
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleChange1 = this.handleChange1.bind(this);
    this.handleChange2 = this.handleChange2.bind(this);
    this.handleChangeFile = this.handleChangeFile.bind(this);

    this.submitForm = this.submitForm.bind(this);
  }

  componentDidMount() {
    this.checkLoggedIn();
  }

  handleChange(event) {
    const { name, value } = event.target;
    this.setState({
      [name]: value,
    });
  }

  handleChange1(event) {
    this.setState(
      {
        departureDate: event.target.value,
      },
      () => {
        this.calculateLengthOfStayInNights();
      },
    );
  }

  handleChange2(event) {
    this.setState(
      {
        arrivalDate: event.target.value,
      },
      () => {
        this.calculateLengthOfStayInNights();
      },
    );
  }

  handleChangeFile(file) {
    console.log(file);
    this.setState({
      files: file,
    });
  }

  async checkLoggedIn() {
    // Not logged in from local storage
    const user = await StorageHandler.load(storageKeys.user);
    if (!user) {
      window.location.href = `${window.location.origin}/login`;
      return;
    }

    if (user) {
      this.setState({
        agentEmail: user.email,
        agentFirstName: user.first_name,
        agentLastName: user.last_name,
        agentCompany: user.agency_name,
        postalCode: user.zip_code,
        agentCity: user.city,
        agentCountry: user.country,
      });
    } else {
      StorageHandler.removeKeys(userKeys);
      window.location.replace('/logout');
    }
  }

  calculateLengthOfStayInNights() {
    const { arrivalDate, departureDate } = this.state;
    const arrival = new Date(arrivalDate);
    const departure = new Date(departureDate);
    const diffTime = Math.abs(departure - arrival);
    let diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    // If diffDays nan, then set to 0
    if (Number.isNaN(diffDays)) {
      diffDays = 0;
    }

    this.setState({
      lengthOfStay: diffDays,
    });
  }

  submitForm(event) {
    event.preventDefault();
    const submit = event.target;
    submit.disabled = true;

    if (['MX', 'CO', 'BR', 'AR', 'CL', 'PE', 'VE', 'EC', 'GT', 'CU', 'BO', 'DO', 'HN', 'PY', 'SV', 'NI', 'PA', 'UY', 'PR'].includes(this.state.agentCountry)) {
      // Make file required for these countries
      if (!this.state.files) {
        toast.error(i18n.translate('rewards.required.rezsnap'), {
          position: 'top-center',
          transition: Zoom,
          autoClose: 10000,
          hideProgressBar: true,
          pauseOnHover: true,
          draggable: true,
        });
        submit.disabled = false;
        return;
      }
    }

    if (!checkInputValidity()) {
      const invalidFields = `Please fill in all the required fields: ${checkInputValidityFields().join(', ')}`;
      toast.error(invalidFields, {
        position: 'top-center',
        transition: Zoom,
        autoClose: 10000,
        hideProgressBar: true,
        pauseOnHover: true,
        draggable: true,
      });
      submit.disabled = false;
      return;
    }

    // Create object to send to API
    const {
      agentEmail,
      agentLastName,
      agentFirstName,
      bookingNumber,
      arrivalDate,
      confirmNumber,
      departureDate,
      ticketNumber,
      lengthOfStay,
      numberOfTravelers,
      routing,
      files,
    } = this.state;

    const reward = {
      booking_number: bookingNumber,
      reservation_number: confirmNumber,
      arrival_date: arrivalDate,
      departure_date: departureDate,
      length_of_stay: lengthOfStay,
      ticket_number: ticketNumber,
      number_of_guests: numberOfTravelers,
      agent_email: agentEmail,
      agent_last_name: agentLastName,
      agent_first_name: agentFirstName,
      appId: baseAppId,
      origin_airport: routing || '',
      files,
    };

    APIHandler.addReward(reward).then((res) => {
      const { Sentry } = this.state;
      if (Sentry !== undefined && Sentry !== null) {
        Raven.captureException('Reward submission', { extra: res });
      }

      if (res.result === 'failed') {
        toast.error('Something went wrong, please try again.', {
          position: 'top-center',
          transition: Zoom,
          autoClose: 10000,
          hideProgressBar: true,
          pauseOnHover: true,
          draggable: true,
        });
        submit.disabled = false;
      } else if (res.message === 'The given data was invalid.') {
        toast.error('Something went wrong, please try again.', {
          position: 'top-center',
          transition: Zoom,
          autoClose: 10000,
          hideProgressBar: true,
          pauseOnHover: true,
          draggable: true,
        });
        submit.disabled = false;
      } else if (res.result === "success") {
        const params = new URLSearchParams(window.location.search);
        if (params.get('mobile')) {
          this.setState({ redirect: '/main/rewards/thank-you?mobile=true' });
        } else {
          this.setState({ redirect: '/main/rewards/thank-you' });
        }
      } else {
        toast.error('Please check your (company) Firewall and/or any other restrictions. '+res.response, {
          position: 'top-center',
          transition: Zoom,
          autoClose: 10000,
          hideProgressBar: true,
          pauseOnHover: true,
          draggable: true,
        });
        submit.disabled = false;
      }
    });
  }

  render() {
    const {
      confirmNumber,
      bookingNumber,

      arrivalDate,
      departureDate,
      lengthOfStay,
      numberOfTravelers,
      ticketNumber,
      agentEmail,
      agentFirstName,
      agentLastName,
      agentCompany,
      redirect,
      postalCode,
      agentCity,
      agentCountry,
      routing,
      files,
    } = this.state;

    const params = new URLSearchParams(window.location.search);
    let mobile = false;
    if (params.get('mobile')) {
      mobile = true;
    }

    return (
      <React.Fragment key={agentEmail}>
        <RewardMenu />

        <BookingForm
          submitForm={this.submitForm}
          handleChange={this.handleChange}
          handleChange1={this.handleChange1}
          handleChange2={this.handleChange2}
          handleChangeFile={this.handleChangeFile}
          confirmNumber={confirmNumber}
          bookingNumber={bookingNumber}
          arrivalDate={arrivalDate}
          departureDate={departureDate}
          ticketNumber={ticketNumber}
          lengthOfStay={lengthOfStay}
          agentEmail={agentEmail}
          agentFirstName={agentFirstName}
          agentLastName={agentLastName}
          agentCompany={agentCompany}
          postalCode={postalCode}
          agentCity={agentCity}
          agentCountry={agentCountry}
          numberOfTravelers={numberOfTravelers}
          routing={routing}
          files={files}
        />
        <ToastContainer draggablePercent={70} />
        {redirect && <Redirect to={redirect} />}
        {mobile && (
          <style>
            {
              '\
      .contentContainer { margin-top: 5rem; } .header { display: none; } .cookieConsent { display: none; }'
            }
          </style>
        )}
      </React.Fragment>
    );
  }
}

export default BookingFormView;
